import CONSTANTS from 'constants';

/**
 * 택배사 운송장 번호로 택배 조회 함수
 * --
 * @param {string} company
 * @param {string} trackingNumber
 * @returns
 */
const trackDelivery = (company, trackingNumber) => {
  if (company === 'DIRECT') {
    return window.alert(
      '업체에서 직접 배송하는 상품은 배송 추적할 수 없습니다.',
    );
  }

  if (!company || !trackingNumber) {
    return window.alert('현재 택배를 추적할 수 없는 상태입니다.');
  }

  const trackingCompany = CONSTANTS.DELIVERY_COMPANY[company];
  if (!trackingCompany || !trackingCompany.url) {
    return window.alert('지원하지 않는 택배사입니다!');
  } else {
    // 택배사 조회 URL에는 하이픈/공백이 없는 송장번호를 전달합니다.
    const normalizedTrackingNumber = String(trackingNumber).replace(
      /[-\s]/g,
      '',
    );
    const trackingUrl = trackingCompany.url.replace(
      ':trackingNumber',
      normalizedTrackingNumber,
    );

    window.open(trackingUrl, '_blank', 'width=1100, height=980');
  }
};

export default trackDelivery;
